

const calculateAge:any = (dateOfBirth: Date) => {
    return dateOfBirth;

}

export default calculateAge;
